import { useTranslation } from "@sagot/i18n";
import { Button, Dialog, DialogClose, DialogContent, RadioGroup } from "@sagot/ui";
import { useState } from "react";
import { IGNORE_REASONS, type GapIgnoreReason } from "./gap-model";

interface IgnoreGapDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pending: boolean;
  onConfirm: (reason: GapIgnoreReason) => void;
}

/** "Ignore this gap?" with a reason (one or many clusters). */
export function IgnoreGapDialog({ open, onOpenChange, pending, onConfirm }: IgnoreGapDialogProps) {
  const { t } = useTranslation();
  const [reason, setReason] = useState<GapIgnoreReason>("out_of_scope");
  const options = IGNORE_REASONS.map((value) => ({ value, label: t(`engage.gaps.ignore.${value}`) }));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-md"
        title={t("engage.gaps.ignore.title")}
        description={t("engage.gaps.ignore.body")}
        closeLabel={t("common.close")}
        footer={
          <>
            <DialogClose asChild>
              <Button variant="secondary">{t("common.cancel")}</Button>
            </DialogClose>
            <Button
              variant="dark"
              loading={pending}
              onClick={() => {
                onConfirm(reason);
              }}
            >
              {t("engage.gaps.ignore.confirm")}
            </Button>
          </>
        }
      >
        <RadioGroup aria-label={t("engage.gaps.ignore.reasonLabel")} variant="cards" options={options} value={reason} onValueChange={setReason} />
      </DialogContent>
    </Dialog>
  );
}
